import * as React from "react";
import { SVGProps } from "react";
const SvgBulletlistSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 12c.904 0 1.808.1 2.711.267.536.1.937.5 1.038 1.033a14.646 14.646 0 0 1 0 5.4 1.28 1.28 0 0 1-1.038 1.033C17.808 19.9 16.904 20 16 20c-.904 0-1.807-.1-2.711-.267-.536-.1-.938-.5-1.038-1.033a14.646 14.646 0 0 1 0-5.4c.1-.533.502-.933 1.038-1.033.813-.15 1.627-.246 2.44-.264L16 12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBulletlistSquare;
